module.exports = __webpack_public_path__ + "media/icons/envelope--blue-25bc0536.svg";